import * as angular from 'angular';
import { NgXServices } from './ngXInjects.index';

const EmptyComponent = {
  template: ''
};

export const NgXModule = angular.module('CrazyWeb.NgX', [NgXServices])
  .component('empty', EmptyComponent)
  .config([
    '$stateProvider',
    $stateProvider => {
      $stateProvider
        .state('app.main', {
          url: '/',
          component: 'empty'
        })
        .state('app.contacts', {
          url: '/contacts',
          component: 'empty'
        })
        .state('app.contact-details', {
          url: '/contact-details/*path',
          component: 'empty'
        })
        .state('app.eventDetails', {
          url: '/event-details/*path',
          component: 'empty'
        })
        .state('app.callDetails', {
          url: '/call-details/*path',
          component: 'empty'
        })
        .state('app.blacklist', {
          url: '/blacklist',
          component: 'empty'
        })
        .state('app.blacklistPath', {
          url: '/blacklist/*path',
          component: 'empty'
        })
        .state('app.ivr', {
          url: '/ivr',
          component: 'empty'
        })
        .state('app.ivrPath', {
          url: '/ivr/*path',
          component: 'empty'
        })
        .state('app.lead-generation', {
          url: '/lead-generation',
          component: 'empty'
        })
        .state('app.lead-generationPath', {
          url: '/lead-generation/*path',
          component: 'empty'
        })
        .state('app.integrations', {
          url: '/integrations',
          component: 'empty'
        })
        .state('app.integrationPath', {
          url: '/integrations/*path',
          component: 'empty'
        })
        .state('app.webhooks', {
          url: '/webhooks',
          component: 'empty'
        })
        .state('app.webhooksPath', {
          url: '/webhooks/*path',
          component: 'empty'
        })
        .state('app.mobileApp', {
          url: '/mobile-app',
          component: 'empty'
        })
        .state('app.reports', {
          url: '/reports',
          component: 'empty'
        })
        .state('app.dashboard', {
          url: '/dashboard',
          component: 'empty'
        })
        .state('app.accountPath', {
          url: '/account/*path',
          component: 'empty'
        })
        .state('app.my-account', {
          url: '/my-account',
          component: 'empty'
        })
        .state('app.my-accountPath', {
          url: '/my-account/*path',
          component: 'empty'
        })
        .state('app.choosePlan', {
          url: '/choose-plan',
          component: 'empty'
        })
        .state('app.get-new-number', {
          url: '/get-new-number',
          component: 'empty'
        })
        .state('app.get-new-numberPath', {
          url: '/get-new-number/*path',
          component: 'empty'
        })
        .state('blocked.get-new-number', {
          url: '/get-first-new-number',
          component: 'empty'
        })
        .state('blocked.get-new-numberPath', {
          url: '/get-first-new-number/*path',
          component: 'empty'
        })
        .state('blocked.first-steps', {
          url: '/first-steps',
          component: 'empty'
        })
        .state('blocked.first-stepsPath', {
          url: '/first-steps/*path',
          component: 'empty'
        })
        .state('blocked.welcome', {
          url: '/welcome',
          component: 'empty'
        })
        .state('blocked.welcomePath', {
          url: '/welcome/*path',
          component: 'empty'
        })
        .state('app.onboarding', {
          url: '/onboarding',
          component: 'empty'
        })
        .state('app.onboardingPath', {
          url: '/onboarding/*path',
          component: 'empty'
        })
        .state('app.call-history', {
          url: '/call-history',
          component: 'empty'
        })
        .state('app.call-historyPath', {
          url: '/call-history/*path',
          component: 'empty'
        })
        .state('blocked.plans', {
          url: '/plans',
          component: 'empty'
        })
        .state('app.api', {
          url: '/developers/api',
          component: 'empty'
        })
        .state('app.widget', {
          url: '/extension',
          component: 'empty'
        })
        .state('app.pricing', {
          url: '/pricing',
          component: 'empty'
        })
        .state('app.numbers', {
          url: '/phone-numbers',
          component: 'empty'
        })
        .state('app.numbersPath', {
          url: '/phone-numbers/*path',
          component: 'empty'
        })
        .state('app.users', {
          url: '/users',
          component: 'empty'
        })
        .state('app.usersPath', {
          url: '/users/*path',
          component: 'empty'
        })
        .state('accounts.choose', {
          url: '/accounts',
          component: 'empty'
        })

        // Uncomment in case possibility to add existing user number will be needed again


        // .state('app.exists-numberPath', {
        //   url: '/exists-number/*path',
        //   component: 'empty'
        // })
        .state('app.address-book', {
          url: '/address-book',
          component: 'empty'
        })
        .state('app.address-bookPath', {
          url: '/address-book/*path',
          component: 'empty'
        })
    }
  ]).name;
